$(document).ready(function () {
  const checkFreeProduct = async () => {
    try {
      const res = await fetch('/cart.json');
      const data = await res.json();

      const freeProductId1 = 50422753001794;
      const freeProductId2 = 50422754312514;

      const itemIdsInCart = data.items.map(item => item.id);
      // const total = data.total_price;
      let dataTotalPrice = 0;
      // data.items.forEach(item => {
      //   if (item.id !== freeProductId1 || item.id !== freeProductId2) {
      //     dataTotalPrice += item.original_line_price;
      //   }
      // });
      const isGiftItem = (id) => id === freeProductId1 || id === freeProductId2;
        data.items.forEach(item => {
          const isBrickDeal = (item.properties.Brick === "true");
          if (!isGiftItem(item.id) && !isBrickDeal) {
            dataTotalPrice += item.original_line_price;
            // console.log(item, 'item');
          }
        });
    // console.log(dataTotalPrice);
      let shouldReload = false;

      const addProduct = async (productId) => {
        const formData = {
          items: [{
            id: productId,
            quantity: 1
          }]
        };
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
        shouldReload = true;
      };

      const removeProduct = async (productId) => {
        await $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            quantity: 0,
            id: productId
          },
          dataType: 'json'
        });
        shouldReload = true;
      };
      
      if (dataTotalPrice < 900000) {
        if (itemIdsInCart.includes(freeProductId1)) {
          await removeProduct(freeProductId1);
        }
        if (itemIdsInCart.includes(freeProductId2)) {
          await removeProduct(freeProductId2);
        }
      } else if (dataTotalPrice >= 900000 && dataTotalPrice < 1600000) {
        if (!itemIdsInCart.includes(freeProductId1)) {
          await addProduct(freeProductId1);
        }
        if (itemIdsInCart.includes(freeProductId2)) {
          await removeProduct(freeProductId2);
        }
      } else if (dataTotalPrice >= 1600000) {
        if (!itemIdsInCart.includes(freeProductId2)) {
          await addProduct(freeProductId2);
        }
        if (itemIdsInCart.includes(freeProductId1)) {
          await removeProduct(freeProductId1);
        }
      }
      if (shouldReload) {
        location.reload();
      }

    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  };

  // checkFreeProduct();
function syncVariantWithMain() {
  var MAIN_VARIANT_ID = 51867350663490;
  var CHILD_VARIANT_ID = 51924723302722;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      var hasMain = false;
      var hasChild = false;

      cart.items.forEach(item => {
        if (item.variant_id == MAIN_VARIANT_ID) {
          hasMain = true;
        }

        if (item.variant_id == CHILD_VARIANT_ID) {
          hasChild = true;
        }
      });

      // 👉 Add child ONLY ONCE
      if (hasMain && !hasChild) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: CHILD_VARIANT_ID,
            quantity: 1
          })
        }).then(() => {
          location.reload();
        });
      }
    });
}

// syncVariantWithMain();

});

$(document).ready(function() {
const checkFreeProduct = async () => {
  try {
    const res = await fetch('/cart.json');
    const data = await res.json();

    const freeProductId = 50422754607426; // Gift Variant ID
    const giftItem = data.items.find(item => item.id === freeProductId);

    const subtotalPaise = data.items_subtotal_price;

    const minRange = 700000;   // ₹7000
    const maxRange = 1200000;  // ₹12000

    let shouldReload = false;

    // ✅ ONLY VALID RANGE (7000 - 11999) → ADD / FIX
    if ( subtotalPaise > maxRange) {

      if (!giftItem) {
        await $.post('/cart/add.js', { id: freeProductId, quantity: 1 });
        shouldReload = true;
      }

      if (giftItem && giftItem.quantity > 1) {
        await $.post('/cart/change.js', { id: freeProductId, quantity: 1 });
        shouldReload = true;
      }

    }
    // ❌ BELOW 7000 → REMOVE
    else{

      if (giftItem) {
        await $.post('/cart/change.js', { id: freeProductId, quantity: 0 });
        shouldReload = true;
      }

    }
    // ⚠️ ABOVE 12000 → DO NOTHING
    // (na add, na remove)

    if (shouldReload) location.reload();

  } catch (error) {
    console.error("Error:", error);
  }
};





    //checkFreeProduct();
});







$(document).ready(function () {

const checkGWP = async () => {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const GWP_CONFIG = [
      {
        tag: "gwp-eligible",
        variantId: 52960146227522
      },
      {
        tag: "gwp-eligible-2",
        variantId: 50422792454466
      }
    ];

    let shouldReload = false;
    const productCache = {};

    for (const config of GWP_CONFIG) {

      let eligibleQty = 0;

      // ✅ multiple line items handle
      let freeItems = [];
      let paidItems = [];

      for (const item of cart.items) {

        // 🎁 FREE GIFT items collect
        if (
          item.variant_id == config.variantId &&
          item.properties &&
          item.properties._free_gift === "true"
        ) {
          freeItems.push(item);
          continue;
        }

        // ❌ PAID duplicate collect
        if (item.variant_id == config.variantId) {
          paidItems.push(item);
          continue;
        }

        // 🔍 product tag check
        if (!productCache[item.handle]) {
          const productRes = await fetch(`/products/${item.handle}.js`);
          productCache[item.handle] = await productRes.json();
        }

        const product = productCache[item.handle];

        if (product.tags.includes(config.tag)) {
          eligibleQty += item.quantity;
        }
      }

      // ❌ Remove ALL paid duplicates
      for (const item of paidItems) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
        shouldReload = true;
      }

      // ❌ No eligible → remove all gifts
      if (eligibleQty === 0 && freeItems.length > 0) {
        for (const item of freeItems) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        }
        shouldReload = true;
        continue;
      }

      // ➕ Eligible > 0
      if (eligibleQty > 0) {

        if (freeItems.length === 0) {
          // ➕ Add fresh gift
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: config.variantId,
              quantity: eligibleQty,
              properties: { "_free_gift": "true" }
            })
          });

          shouldReload = true;

        } else {
          // ✅ Keep only ONE gift line
          const mainGift = freeItems[0];

          // remove extra gift lines
          for (let i = 1; i < freeItems.length; i++) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: freeItems[i].key,
                quantity: 0
              })
            });
            shouldReload = true;
          }

          // ✅ update correct quantity
          if (mainGift.quantity !== eligibleQty) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: mainGift.key,
                quantity: eligibleQty
              })
            });

            shouldReload = true;
          }
        }
      }
    }

    if (shouldReload) {
      location.reload();
    }

  } catch (error) {
    console.error("GWP Error:", error);
  }
};

  checkGWP();

});